import Vue from 'vue';
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import PageTitleHelper from '../Helpers/pageTitle.helper';
export default {
  data() {
    return {
      time: '',
      drawer: true,
      mini: true,
      myIntrval: null,
      userExtension: '',
      ringingModal: false,
      uniqueId: null,
      callerId: '',
      destination: '',
      newForm: false,
      deploymentModal: false,
      showExtension: false,
      changeRoleModalFlag: false,
      changeRolePageType: 'extension',
      selectedRoleForChange: '',
      userRoleEnglishTitle: '',
      userRoleIdForLogin: '',
      newFormType: 'call',
      newFormList: [],
      newTabForm: null,
      selectFormList: 0,
      showDialogNewform: false,
      callInformationModel: null,
      allowUsingDND: false,
      isDnd: false,
      dndTime: '',
      dndTimeInterval: null,
      startDNDTime: '',
      isNotificationBarOpen: false,
      recordFileHome: '',
      playerHome: false,
    };
  },
  mixins: [PageTitleHelper],
  methods: {
    stopMusicHome: function () {
      var soundHome = this.$refs.audioFileHome;
      soundHome.pause();
      soundHome.currentTime = 0;
      this.playerHome = false;
    },
    pauseMusicHome: function () {
      var soundHome = this.$refs.audioFileHome;
      soundHome.pause();
    },
    // setNotificationBarOpen
    setNotificationBarOpen: function (value) {
      this.isNotificationBarOpen = value;
    },
    interval: function () {
      this.myIntrval = setInterval(() => {
        this.refresh();
      }, 60 * 60 * 1000);
    },
    refresh: function () {
      this.$store.dispatch('refreshToken').then(() => {
        if (!this.$store.state.userModule.successFlag) {
          // this.$router.push({ name: "login" });
        }
      });
    },
    getNow: function () {
      this.time = Vue.moment().format('HH:mm:ss - jYYYY/jM/jD');
    },
    goToProfile: function () {
      this.$router.push({ name: 'profile' });
    },
    closeForm: function (unId) {
      // this.selectFormList = 0
      this.changeToOldTitle();
      this.$store.dispatch("setSelectedTriageAnswersDispatch", []); //for reseting selectedTriageAnswers
      // if (this.newFormList?.length) this.newFormList.pop();
      // for (let i = 0; i < this.newFormList.length; i++) {
      //   if (this.newFormList[i].uniqueId == unId) {
      //     this.newFormList[i].newForm = false;
      //     this.newFormList.splice(i, 1);
      // break;
      //   }
      // }
      const index = this.newFormList.findIndex(item => item.uniqueId == unId);

      if (index !== -1) {
        this.newFormList[index].newForm = false;
        this.newFormList.splice(index, 1);

        if (this.newFormList.length > 0) {
          if (index === 0) {
            this.selectFormList = 0;
          }
          else {
            this.selectFormList = index - 1;
          }
        } else {
          this.selectFormList = 0;
          this.showDialogNewform = false;
        }
      }

      if (this.newFormList.length == 0) {
        this.showDialogNewform = false
        if (this.$route.name === "mission115" && this.$root.$refs.Mission115View) {
          this.$root.$refs.Mission115View.getListOfCurrentMissionFunction();
        }
      }
    },
    activateDeployment: function () {
      this.deploymentModal = true;
    },
    closeDeploymentForm: function () {
      this.deploymentModal = false;
    },
    activateNewCallFor800: function () {
      let uniqeId = uuidv4();
      let user = this.$store.state.userModule.user;

      let objNewForm = {
        newForm: true,
        uniqueId: uniqeId.replaceAll("-", ""),
        callerId: "",
        destination: "",
        newFormType: "hand",
      }
      if (user.currentExtension) {
        objNewForm["destination"] = user.currentExtension.sipExtension;
      }

      this.newFormList.push(objNewForm);
      this.showDialogNewform = true
    },

    loadFromLocalStorage_selectStateMission() {
      const mRoute = this.$route.path;
      const saved = localStorage.getItem('selectMissonState');
      if (saved == "true") {
        this.$router.push({ name: 'currentMission800' });
        if (!mRoute?.includes('/800/')) {
          this.navigateTo('newMissionWithMap800');
        }
        setTimeout(() => {
          if (!mRoute?.includes('/800/')) {
            window.location.reload();
          }
        }, 1000);

        return
      }
      this.$router.push({ name: 'mission800' });
      if (!mRoute?.includes('/800/')) {
        this.navigateTo('dispatchMap');
      }
      setTimeout(() => {
        if (!mRoute?.includes('/800/')) {
          window.location.reload();
        }
      }, 1000);
    },

    showChangeRoleModal: function (type) {
      if (type == '800') {
        this.selectedRoleForChange = type;
        this.userRoleEnglishTitle = 'User800';
        this.userRoleIdForLogin = 2;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.loadFromLocalStorage_selectStateMission()
        // const routeData = this.$router.resolve({ name: 'mission800' });
        // setTimeout(() => {
        //   window.location.reload();
        // }, '1000');
        // window.open(routeData.href, '_blank');
        // this.$router.push({ name: 'dispatchMap' });
      } else if (type == '115') {
        this.userRoleEnglishTitle = 'User115';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 3;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'mission115' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'admission') {
        this.userRoleEnglishTitle = 'Admission';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 6;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'admissionMap' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
        // const routeData = this.$router.resolve({ name: 'dashboardAdmission' });
        const routeData = this.$router.resolve({ name: 'admissionMissions' });
        window.open(routeData.href, '_blank');
      } else if (type == 'followUp') {
        this.userRoleEnglishTitle = 'FollowUp';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 7;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboardFollowUp' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'doctor') {
        this.userRoleEnglishTitle = 'Doctor';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 8;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'doctorDashboard' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'hospital') {
        this.userRoleEnglishTitle = 'Hospital';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 9;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'hospitalMissions' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'qc') {
        this.userRoleEnglishTitle = 'QC';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 10;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'qcDashboard' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'amar') {
        this.userRoleEnglishTitle = 'statistic';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 11;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'amarDashboard' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'OtherOrganization') {
        this.userRoleEnglishTitle = 'OtherOrganization';
        this.selectedRoleForChange = type;
        this.userRoleIdForLogin = 12;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'otherOrganizationMissions' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (type == 'eoc') {
        this.selectedRoleForChange = type;
        this.userRoleEnglishTitle = 'EOC';
        this.userRoleIdForLogin = 14;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'currentMissionEoc' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
        // const routeData = this.$router.resolve({ name: 'currentMissionEoc' });
        // window.open(routeData.href, '_blank');
      } else if (type == 'dashboards') {
        this.selectedRoleForChange = type;
        this.userRoleEnglishTitle = 'Dashboards';
        this.userRoleIdForLogin = 15;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboards_115' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      }
    },
    confirmedExtension: function (extension) {
      this.setExtensionFunction(extension);
    },
    confirmedZone: function (zone) {
      this.setZoneFunction(zone);
    },
    checkForLoginUser: function () {
      if (this.userRoleEnglishTitle == 'User115') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboard115' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (this.userRoleEnglishTitle == 'User800') {
        this.changeRolePageType = 'zone';
        this.getAllZones();
      } else if (this.userRoleEnglishTitle == 'Admission') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'admissionMap' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
        // const routeData = this.$router.resolve({ name: 'dashboardAdmission' });
        const routeData = this.$router.resolve({ name: 'admissionMissions' });
        window.open(routeData.href, '_blank');
      } else if (this.userRoleEnglishTitle == 'FollowUp') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboardFollowUp' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (this.userRoleEnglishTitle == 'Doctor') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'doctorDashboard' });
        setTimeout(() => {
          window.location.reload();
        }, '1000');
      } else if (this.userRoleEnglishTitle == 'EOC') {
        this.changeRolePageType = 'zone';
        this.getAllZones();
      }
    },
    checkForLogin800User: function () {
      let id = this.userRoleIdForLogin.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
      localStorage.setItem('dash', encryptId);
      this.setTheme('red');
      const routeData = this.$router.resolve({ name: 'dashboard800' });
      setTimeout(() => {
        window.location.reload();
      }, '1000');
      window.open(routeData.href, '_blank');
      this.$router.push({ name: 'dispatchMap' });
    },
    cancleChangeRole: function () {
      this.changeRolePageType = 'extension';
      this.changeRoleModalFlag = false;
    },
    setTheme: function () {
      let theme = localStorage.getItem('theme');
      if (theme) {
        if (theme == 'blue') {
          localStorage.setItem('darkColor', '#04468B');
          localStorage.setItem('lightColor', '#0A6ADA');
          localStorage.setItem('iconColor', '#0A6ADA');
          localStorage.setItem('background', '#F6FBFF');
          localStorage.setItem('textLightColor', '#4173a8');
          localStorage.setItem('modalBorder', '#04468B');
          localStorage.setItem('oneFieldcolor', '#81A3C5');
          localStorage.setItem('newCallEffect', '#70B2FF');
          this.$vuetify.theme.currentTheme.darkColor = '#04468B';
          this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.background = '#F6FBFF';
          this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
          this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
          this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
          this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
        }
      } else {
        localStorage.setItem('theme', 'blue');
        localStorage.setItem('darkColor', '#04468B');
        localStorage.setItem('lightColor', '#0A6ADA');
        localStorage.setItem('iconColor', '#0A6ADA');
        localStorage.setItem('background', '#F6FBFF');
        localStorage.setItem('textLightColor', '#4173a8');
        localStorage.setItem('modalBorder', '#04468B');
        localStorage.setItem('oneFieldcolor', '#81A3C5');
        localStorage.setItem('newCallEffect', '#70B2FF');
        this.$vuetify.theme.currentTheme.darkColor = '#04468B';
        this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.background = '#F6FBFF';
        this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
        this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
        this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
      }
      this.$root.$refs.appView.themConfig();
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
